<template>
  <div id="center">
    <div id="content" class="content">
      <div class="center_content">
        <div class="paper-ctn clearfix">
          <div class="top-ctn clearfix">
            <div class="title-ctn clearfix">
              {{ commentPageData.projectName }}课程使用评价
            </div>
            <span class="back-btn" onclick="history.go(-1);">返回列表</span>
          </div>
          <div class="vote-step1">
            <!-- <div class="item-time-box clearfix">
              <div class="first-done-time">
                <p class="d-title">首次实验完成时间<i class="iconfont"></i></p>
                <p class="d-time">2021年08月04日 16:55:49</p>
              </div>
            </div> -->
            <div class="item clearfix">
              <span class="label-title">
                {{ commentPageData.templateName }}</span
              >
            </div>
            <div class="item clearfix">
              <span class="label">负责人：</span
              ><span class="text">{{ commentPageData.projectLeader }}</span>
            </div>
            <div class="item clearfix">
              <span class="label">实验简介：</span>
              <div
                class="k-container clearfix"
                v-html="commentPageData.introduction"
              ></div>
            </div>
            <div class="item clearfix hide">
              <span class="label">评价说明：</span>
              <div class="k-container clearfix"></div>
            </div>
          </div>
          <div class="vote-step2">
            <div class="r-title"><span class="text">动态评分</span></div>
            <div class="star-ctn clearfix">
              <div class="star-item item1" data-id="1">
                <div class="star-title">
                  <div class="theName">*实验内容：</div>

                  <div class="theExperiment">
                    <el-rate v-model="evaluationOfTheRequest.star1"></el-rate>
                  </div>
                </div>
              </div>
              <div class="star-item item2" data-id="2">
                <div class="star-title">
                  <div class="theName">*操作系统：</div>

                  <div class="theExperiment">
                    <el-rate v-model="evaluationOfTheRequest.star2"></el-rate>
                  </div>
                </div>
              </div>
              <div class="star-item item3" data-id="3">
                <div class="star-title">
                  <div class="theName">*支持服务：</div>

                  <div class="theExperiment">
                    <el-rate v-model="evaluationOfTheRequest.star3"></el-rate>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="vote-step3">
            <div class="r-title clearfix">
              <span class="text">评价</span>
              <div class="p-result"></div>
            </div>
            <div class="problem-list list list-grop" id="problem-list">
              <!-- <div
                class="list-group-item p-item p-item-1"
                id="q1"
                data-id="1"
                data-index="0"
                data-require="1"
                data-type="3"
              >
                <span class="p-require r-1">必填</span>
                <div class="p-ctn">
                  <div class="p-title">
                    Q1、您使用该虚拟仿真实验教学课程时遇到过哪些阻碍或困难？多选题
                  </div>
                  <div class="options options-normal">
                    <div class="option">
                      <input
                        data-id="1"
                        data-index="0"
                        type="checkbox"
                        name="q1"
                        id="q1_1"
                        value="0"
                      /><label for="q1_1" class="key1"
                        >没有遇到过任何困难或阻碍</label
                      >
                    </div>
                    <div class="option">
                      <input
                        data-id="1"
                        data-index="1"
                        type="checkbox"
                        name="q1"
                        id="q1_2"
                        value="1"
                      /><label for="q1_2" class="key2">缺少VR/AR设备</label>
                    </div>
                    <div class="option">
                      <input
                        data-id="1"
                        data-index="2"
                        type="checkbox"
                        name="q1"
                        id="q1_3"
                        value="2"
                      /><label for="q1_3" class="key3"
                        >硬件性能和网速跟不上</label
                      >
                    </div>
                    <div class="option">
                      <input
                        data-id="1"
                        data-index="3"
                        type="checkbox"
                        name="q1"
                        id="q1_4"
                        value="3"
                      /><label for="q1_4" class="key4"
                        >缺少技术支持和指导</label
                      >
                    </div>
                    <div class="option">
                      <input
                        data-id="1"
                        data-index="4"
                        type="checkbox"
                        name="q1"
                        id="q1_5"
                        value="4"
                      /><label for="q1_5" class="key5"
                        >容易出现晕眩、眼睛疲劳等生理不适</label
                      >
                    </div>
                  </div>
                </div>
              </div> -->
              <div
                class="list-group-item p-item p-item-2"
                id="q2"
                data-id="2"
                data-index="1"
                data-require="1"
                data-type="4"
              >
                <span class="p-require r-1">必填</span>
                <div class="p-ctn">
                  <div class="p-title">Q1、请填写评价内容。</div>
                  <textarea
                    data-id="2"
                    class="simple"
                    name="q2"
                    v-model="evaluationOfTheRequest.content"
                    placeholder="请输入评价内容"
                     minlength="5"
                    maxlength="200"
                    @input="descInput"
                  ></textarea>
                  <p class="q-desc q-desc-2">
                    还可以输入<span class="num_remaining">{{ remnant }}</span
                    >个字
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="control-ctn">
            <div class="submit-btn" @click="accessToProjectHomePage()">
              提交
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, reactive } from "vue";
import { evaluationOfNew, courseDetailsFor } from "../assets/api/index";
import router from "../router/index.js";
import { ElMessage } from "element-plus";
export default {
  setup() {
    const tableData = ref();

    //课程评价新增
    const evaluationOfTheRequest = reactive({
      uid: localStorage.getItem("userId"),
      content: "",
      courseId: localStorage.getItem("courseid"),
      star1: 0,
      star2: 0,
      star3: 0,
      star4: 0,
      star5: 5,
    });
    const accessToProjectHomePage = () => {
      evaluationOfNew(evaluationOfTheRequest).then((res) => {
        tableData.value = res.rows;

        if (res.code == 400) {
          ElMessage.error(res.msg);
          router.push("projectDetails");
        } else {
          ElMessage.success(res.msg);
        }
      });
    };

    //获取
    const forTheRequest = reactive({
      id: localStorage.getItem("courseid"),
      uid: localStorage.getItem("userId"),
    });
    const commentPageData = ref([]);
    const getData = () => {
      courseDetailsFor(forTheRequest).then((res) => {
        commentPageData.value = res.data;
      });
    };
    getData();

    const remnant = ref();
    const descInput = () => {
      var txtVal = evaluationOfTheRequest.content.length;
      remnant.value = 200 - txtVal;
    };

    return {
      getData,
      descInput,
      remnant,
      commentPageData,
      forTheRequest,
      tableData,
      evaluationOfTheRequest,
      accessToProjectHomePage,
    };
  },

  name: "HelloWorld",
};
</script>

<style scoped>
@import "../assets/css/vote.css";
.star-title {
  display: flex;
}
.k-container.clearfix p,
.k-container.clearfix span {
  font-size: 14px;
  font-family: "微软雅⿊" !important;
}
</style>